import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

export function formatDate(date) {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, 'PPP', { locale: ar });
}

export function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}

export function parseDate(dateString) {
  const date = new Date(dateString);
  return isValidDate(date) ? date : null;
}